module.exports = __webpack_public_path__ + "static/5-399a9e45cf90b2fe2b6a80ba2b840e9f.jpg";